/**
 * Returns the 128×128 -thumb.webp URL for profile pictures used in small avatar
 * contexts (≤64px display). Falls back to the original URL unchanged if the
 * source isn't an -opt.webp (e.g. very old accounts pre-backfill).
 *
 * Use onError={profileThumbFallback(originalUrl)} alongside this so that if the
 * thumb file doesn't exist on disk yet the browser falls back to the full-size opt.
 */
/**
 * Returns the -opt.webp derivative URL for audio/video cover art.
 * If the URL already ends in -opt.webp it is returned unchanged.
 * Falls back to the original URL if no dot is found.
 */
export const optimizedCover = (url) => {
    if (!url || url.endsWith('-opt.webp')) return url;
    const dot = url.lastIndexOf('.');
    return dot !== -1 ? url.slice(0, dot) + '-opt.webp' : url;
};

export const profileThumb = (url) => {
    if (!url) return url;
    if (url.endsWith('-opt.webp')) return url.slice(0, -9) + '-thumb.webp';
    return url;
};

/**
 * onError handler that falls back from -thumb.webp to the full -opt.webp.
 * Usage: onError={profileThumbFallback(profilePictureUrl)}
 */
export const profileThumbFallback = (fallbackUrl) => (e) => {
    e.target.onerror = null;
    e.target.src = fallbackUrl || '';
};
